import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import ReactLoading from 'react-loading';
import React from 'react'
import { StyleSheet, css } from 'aphrodite';



const ADMIN_LOGIN = gql`
  mutation AdminLogin($user: String,$pass: String){
    adminLogin(
      user: $user,
      pass: $pass,
    ){
      token
    }
  }
`;


class LoginPopup extends React.Component {
  state = {
    user:"",
    pass:"",
  }


  componentDidMount(){
    
  }


  render(){
    

    return(
      <Mutation mutation={ADMIN_LOGIN}>
        {(adminLogin, { data, loading, error }) => {
          if(error){
            console.log(error.message)
          }
          if(data){
            window.localStorage.setItem("token", data.adminLogin.token);
            this.props.refetch()
            console.log(data)
            return(
              <div className={css(styles.button)}>
               <ReactLoading type={"bubbles"} color={"#fff"} height={24} width={24} />
              </div>
            )
          }
          
          return(
            <div className={css(styles.wrapper)}>
              <div className={css(styles.innerWrapper)}>
                <div className={css(styles.title)}>Admin Login</div>
                <div className={css(styles.inputContainer)}>
                  <input
                    className={css(styles.input)}
                    onChange={e => this.setState({user: e.nativeEvent.target.value})}
                    value={this.state.user}
                    id={"user"}
                    type="text" 
                    pattern=".+" 
                    required 
                  />
                  <label className={css(styles.label)} onClick={()=>document.getElementById("user").focus()} htmlFor="categoryName1">USER</label>
                </div>
                <div className={css(styles.inputContainer)}>
                  <input
                    className={css(styles.input)}
                    onChange={e => this.setState({pass: e.nativeEvent.target.value})}
                    value={this.state.pass}
                    id={"pass"}
                    type="text" 
                    pattern=".+" 
                    required 
                  />
                  <label className={css(styles.label)} onClick={()=>document.getElementById("pass").focus()} htmlFor="categoryName1">PASS</label>
                </div>
                <React.Fragment>
                  {!loading ?
                  <div
                    className={css(styles.button)}
                    onClick={()=>{
                      adminLogin({
                        variables: { 
                          user: this.state.user,
                          pass: this.state.pass,
                        }
                      });
                    }}
                  >LOG IN
                  </div>
                
                  :
                  <div className={css(styles.button)}>
                    <ReactLoading type={"bubbles"} color={"#fff"} height={24} width={24} />
                  </div>
                }
                </React.Fragment>
              </div>
            </div>
          )
        }}
      </Mutation>
    )
  }
}


const styles = StyleSheet.create({
  
  wrapper:{
    
    position:"fixed",
    display:"flex",
    alignItems:"center",
    top:0,
    left:0,
    right:0,
    bottom:0,
    zIndex:100,
    background:"rgba(0, 0, 0, 0.2)",
    justifyContent:"center",
    flexDirection:"column",
  },
  innerWrapper:{
    textAlign:"center",
    width:"calc(100% - 50px)",
    background:"#fff",
    padding:"50px 30px",
    boxShadow: "0 10px 25px 0 rgba(84,100,123,0.16)",
    maxWidth:340,
  },
  title:{
    fontSize:30,
    fontWight:600,
    marginBottom:40,
  },
  inputContainer:{
    position: "relative",
    margin:"auto",
    marginTop:40,
    marginBottom:40,
    width:"100%",
  },
  label:{
    top: 0,
  left: 0, 
  right: 0,
  color: "#A3A3A3",
  display: "flex",
  alignItems: "center",
  position: "absolute",
  fontSize: 12,
  cursor: "text",
  transition: ".2s ease-in-out",
  boxSizing: "border-box",
  width: "100%",
  height: 30,
  ":focus":{
    color: "#A3A3A3",
    fontSize: 10,
    top: -25,
    pointerEvents: "none",
  },
  },
  input:{
    border: 0,
  borderBottom: "2px solid #9e9e9e",
  outline: "none",
  background: "transparent",
  transition: ".2s ease-in-out",
  boxSizing: "border-box",
  width: "100%",
  height: 30,
  borderRadius:0,
  fontSize: 12,
  ":valid":{
    borderBottom: "2px solid #000",  
  },
  ":focus":{
    borderBottom: "2px solid #000",
  },
  ":valid + label":{  
    color: "#A3A3A3",
    fontSize: 12,
    top: -25,
    pointerEvents: "none",
  },
  ":focus + label":{
    color: "#A3A3A3",
    fontSize: 12,
    top: -25,
    pointerEvents: "none",
  },
  '@media (max-width: 900px)': {
    fontSize:14,
    ":valid + label":{  
      color: "#A3A3A3",
      fontSize: 14,
      top: -25,
      pointerEvents: "none",
    },
    ":focus + label":{
      color: "#A3A3A3",
      fontSize: 14,
      top: -25,
      pointerEvents: "none",
    },
  },
  },
  button:{
    border:"none",
    margin:"0 auto",
    letterSpacing: "0.163636px",
    position:"relative",
    background:"#3A80E4",
    color:"#fff",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    textDecoration:"none",
    height:32,
    cursor:"pointer",
    outline:"none",
    borderRadius:"25px",
    fontSize:12,
    lineHeight:"14px",
    fontWeight:500,
    maxWidth:140,
    userSelect:"none",
    transition:"0.3s",
    ":hover":{
      background:"#266CD0",
    },
    '@media (max-width: 420px)': {
      fontSize:14,
      padding:"13px 26px 13px 26px",
    }
  },


});


export default LoginPopup